import { Injectable, signal } from '@angular/core';
import { EventData, EventInteractionService } from '@mare-common/ngx-mare-common';
import { TokenServiceInterface } from '@mare-common/ngx-mare-auth/lib/token-service.interface';
import { OAuthService, NullValidationHandler, AuthConfig, OAuthEvent, LoginOptions } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
// import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { DelfiChannelService } from './delfi-channel.service';



export const authCodeFlowConfig: AuthConfig = {
  // Url of the Identity Provider
  // issuer: 'https://accounts.maredigital.it/realms/SC_USERS',
  issuer: environment.oauthConfig.oauthIssuer,
  requireHttps: environment.oauthConfig.oauthIssuer.startsWith('https://'),

  // URL of the SPA to redirect the user to after login
  // redirectUri: window.location.origin + (environment.routingBasePath && environment.routingBasePath !== '/' ? '/' + environment.routingBasePath : '') + '/dashboard',
  redirectUri: window.location.origin + (environment.routingBasePath && environment.routingBasePath !== '/' ? '/' + environment.routingBasePath : '') + '/' + environment.routingLoginRedirect,

  // redirectUri: window.location.origin + (environment.routingBasePath && environment.routingBasePath !== '/' ? '/' + environment.routingBasePath : '')+'/dashboard',


  // The SPA's id. The SPA is registerd with this id at the auth-server
  // clientId: 'server.code',
  clientId: environment.oauthConfig.oauthClientId, //'web',

  // Just needed if your auth server demands a secret. In general, this
  // is a sign that the auth server is not configured with SPAs in mind
  // and it might not enforce further best practices vital for security
  // such applications.
  // dummyClientSecret: 'secret',

  responseType: environment.oauthConfig.oauthResponseType, //'code',

  // set the scope for the permissions the client should request
  // The first four are defined by OIDC.
  // Important: Request offline_access to get a refresh token
  // The api scope is a usecase specific one
  scope: environment.oauthConfig.scope,
  disableAtHashCheck: environment.oauthConfig.disableAtHashCheck,
  showDebugInformation: environment.oauthConfig.showDebugInformation,
  checkOrigin: environment.oauthConfig.checkOrigin,

  loginUrl: environment.oauthConfig.documentConfig?.loginUrl,
  logoutUrl: environment.oauthConfig.documentConfig?.logoutUrl,
  userinfoEndpoint: environment.oauthConfig.documentConfig?.userinfoEndpoint,
  // grantTypesSupported: environment.oauthConfig.grantTypesSupported,
  tokenEndpoint: environment.oauthConfig.documentConfig?.tokenEndpoint,
  // jwksUri: environment.oauthConfig.jwksUri,
  jwks: environment.oauthConfig.documentConfig?.jwks,
  sessionCheckIFrameUrl: environment.oauthConfig.documentConfig?.sessionCheckIFrameUrl,
  revocationEndpoint: environment.oauthConfig.documentConfig?.revocationEndpoint


};

@Injectable({
  providedIn: 'root'
})
export class TokenService implements TokenServiceInterface {
  code: any;
  state: any;

  params: any;
  basicauth!: string;
  logged: boolean = false;
  randomId: string = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

  loggedSignal = new BehaviorSubject<boolean>(false);
  // loggedSignal!: Subject<boolean>;
  // loggedSignal = signal<boolean>(false);

  isInit: boolean = false;
  isInit$ = new BehaviorSubject<boolean>(false);
  userEmailToken!: string;

  constructor(
    private oauthService: OAuthService,
    private eventInteractionService: EventInteractionService,
    // private location: Location,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private delfiChannelService: DelfiChannelService
  ) {
    // this.loggedSignal = new Subject<boolean>();
    // this.loggedSignal.next(false);
    this.code = this.findGetParameter('code');
    this.state = this.findGetParameter('state');

    // if(this.code && this.state) {
    this.init(() => {
      this.getAccessToken();
      this.isLogged();
    });
    // }

    this.eventInteractionService.getObservable().subscribe((event: EventData) => {
      if (event.event === 'delfiChannel' && event.data &&
        (event.data.event === 'login' || event.data.event === 'logout')) {
        // const confirmation = window.confirm('Attenzione! In un altro tab è cambiata la sessione. Ricarico?');
        // if (confirmation) {
          window.location.reload();
        // }
      }
    })
  }
  triggerRefreshAndRetrieve(): Promise<any> {
    throw new Error('Method not implemented.');
  }

  init(callback?: Function) {
    // console.log('ngOnInit TokenService');

    this.oauthService.events.subscribe(({ type }: OAuthEvent) => {
      // console.log(.log('oauth/oidc event', type);
      switch (type) {
        case 'token_received':
          console.log('OK ---------------------------- token_received');
          this.isLogged();
          const access_token = this.getAccessToken();
          // if(access_token) {
          //   this.extractInformationsAndStore(access_token);
          // }
          this.eventInteractionService.publishData({ event: 'login', data: access_token });
          break;
        case 'token_refresh_error':
          console.log('ERROR ------------------------- token_refresh_error');
          this.logout();
          break;
        case 'silent_refresh_timeout':
          console.log('silent_refresh_timeout');
          this.logout();
          break;
        case 'session_error':
          console.log('ERROR ------------------------- session_error');
          this.logout();
          break;
      }
    });
    // console.log('authCodeFlowConfig', authCodeFlowConfig)
    this.oauthService.configure(authCodeFlowConfig);
    // this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    this.oauthService.tokenValidationHandler = new NullValidationHandler();
    this.oauthService.scope = 'openid profile email offline_access';
    this.oauthService.setupAutomaticSilentRefresh();

    if (environment.oauthConfig.documentConfig) {
      this._init(callback);
    } else {
      this.oauthService.loadDiscoveryDocument().then(() => {
        this._init(callback);
      });
    }
  }

  _init(callback?: Function) {
    if (this.code && this.state) {
      let options: LoginOptions | undefined;
      if (window.location.pathname != '/' + environment.routingBasePath + '/dashboard') {
        let url = window.location.origin + window.location.pathname;
        let params: URLSearchParams = new URLSearchParams(window.location.search);
        if (params.has('code')) {
          params.delete('code');
        }
        if (params.has('state')) {
          params.delete('state');
        }
        if (params.has('session_state')) {
          params.delete('session_state');
        }
        const queryParams = params.toString();
        if (queryParams && queryParams.length > 0) {
          url = url + '?' + queryParams;
        }
        options = {
          customRedirectUri: url
        }
      }
      this.oauthService.tryLoginCodeFlow(options).then(() => {
        this.isInit = true;
        this.isInit$.next(this.isInit);
        if (callback) {
          callback();
        }
        setTimeout(() => {
          const access_token = this.getAccessToken();
          // if (access_token) {
          //   this.extractInformationsAndStore(access_token);
          // }
          this.eventInteractionService.publishData({ event: 'login', data: access_token });
          this.delfiChannelService.sendData({ event: 'login', data: access_token });
        }, 250);
      });
      // this.location.replaceState(window.location.pathname);
      // this.router.navigate(
      //   [],
      //   {
      //     relativeTo: this.activatedRoute,
      //     queryParams: { code: null, state: null },
      //     queryParamsHandling: 'merge'
      //   }
      // );
      return;
    } else {
      this.isInit = true;
      this.isInit$.next(this.isInit);
    }
    if (callback) {
      callback();
    }
  }



  extractInformationsAndStore(access_token: string) {
    const splitted = access_token.split('.');
    const base64 = splitted[1];

    const decoded = atob(base64);
    sessionStorage.setItem('defli_decoded_info', decoded);
    // this.oauthService.loadUserProfile().then((userProfile: any) => {
    //   // console.log('userProfile', userProfile);
    // });
  }

  getUserEmailToken(): string {
    if (!this.userEmailToken) {
      const decoded_info = sessionStorage.getItem('defli_decoded_info');
      if (decoded_info) {
        this.userEmailToken = JSON.parse(decoded_info).email;
      }
    }
    return this.userEmailToken;
  }

  findGetParameter(parameterName: string) {
    if (!this.params) {
      this.extractGetParameters();
    }
    return this.params[parameterName];
  }

  extractGetParameters() {
    var tmp = [];
    this.params = {};
    location.search
      .substr(1)
      .split("&")
      .forEach((item) => {
        tmp = item.split("=");
        this.params[tmp[0]] = decodeURIComponent(tmp[1]);
      });
  }

  start(params?: any | undefined, redirectUri?: string | undefined) {
    if (!this.isInit) {
      this.init(this.start.bind(this));
    }

    if (!redirectUri && params && params.redirect_uri) {
      redirectUri = params.redirect_uri;
      delete params.redirect_uri;
    }

    if (redirectUri && redirectUri.trim() != '') {
      this.oauthService.redirectUri = redirectUri;
    }
    this.oauthService.initCodeFlow(undefined, params);
    if (this.oauthService.getAccessToken()) {
      console.log("start Access Token = ", this.oauthService.getAccessToken());
    }
  }

  check() {
    // console.log('check');
    let t = this.oauthService.getAccessTokenExpiration();
    console.log(
      this.oauthService.hasValidAccessToken(),
      this.oauthService.hasValidIdToken(),
      this.oauthService.getIdentityClaims(),
      // this.oauthService.getAccessTokenExpiration(),
      // this.oauthService.getAccessToken()
    );
    if (t) {

      console.log(new Date(t));
    }

  }
  refresh() {
    console.log('refresh');
    this.oauthService.refreshToken();
  }

  setLoggedSignal(value: boolean, timeout?: number) {
    if (timeout == undefined || timeout == null) {
      timeout = 250;
    }
    setTimeout(() => {
      this.loggedSignal.next(value);
      // this.loggedSignal.set(value);
    }, timeout);
  }

  isLogged(): boolean {

    if (!this.isInit) {
      return false;
    }

    // console.log('isLogged');
    if (this.oauthService.getAccessToken() && this.oauthService.hasValidAccessToken()) {
      if (!this.logged) {
        this.setLoggedSignal(true);
        // this.loggedSignal.next(true);
        // this.loggedSignal.set(true);
      }
      this.logged = true;
    } else {
      if (this.logged) {
        this.setLoggedSignal(false);
        // this.loggedSignal.next(false);
        // this.loggedSignal.set(false);
      }
      this.logged = false;
    }

    // console.log(this.logged ? "is Logged" : "Not Logged");
    return this.logged;
  }

  getAccessToken(): string {
    // console.log("getAccessToken");

    if (!this.isInit) {
      return "";
    }
    // this.check();

    if (this.oauthService.getAccessToken() && !this.oauthService.hasValidAccessToken()) {
      console.log("Token esistente ma scaduto e lo aggiorno");
      this.oauthService.refreshToken();
    } else if (!this.oauthService.getAccessToken() || !this.oauthService.hasValidAccessToken()) {
      console.log("Token NON esistente e redirigo alla login");
      //this.oauthService.initCodeFlow();
    } else if (this.oauthService.getAccessToken() && this.oauthService.hasValidAccessToken()) {
      this.basicauth = this.oauthService.getAccessToken();
    }

    return this.oauthService.getAccessToken();

  }

  logout() {
    console.log("logout");
    this.oauthService.revokeTokenAndLogout().then((logoutResponse) => {
      console.log("logoutResponse", logoutResponse);
    }).catch((err) => {
      console.log("err", err);
    }).finally(() => {
      if (this.logged) {
        this.setLoggedSignal(false);
        // this.loggedSignal.next(false);
        // this.loggedSignal.set(false);
      }
      this.logged = false;
      this.eventInteractionService.publishData({ event: 'logout', data: null });
      this.delfiChannelService.sendData({ event: 'logout', data: null });

    });

  }

  setTokenObj(payload: any): any {
    throw new Error('Method not implemented.');
  }
  getValidToken(): any {
    if (this.isLogged()) {
      return this.getAccessToken();
    }
    return null;
  }
}